// extracted by mini-css-extract-plugin
export default {"Position":"Go5st","skeleton-progress":"W-K1V"};